import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "order-excel-info-select-modal" }
const _hoisted_2 = { class: "order-excel-info-select-modal__description" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = ["value", "checked", "onChange"]
const _hoisted_5 = { class: "order-excel-info-select-modal__item-content" }
const _hoisted_6 = { class: "order-excel-info-select-modal__name" }
const _hoisted_7 = { class: "order-excel-info-select-modal__meta" }

import type { RegisterOrderExcelInfo } from '@/coreDomainsModule/entities/InputOrderExcelInfo';
import { i18n } from '@/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderExcelInfoSelectModalContent',
  props: {
    orderExcelInfos: {},
    selectedId: {}
  },
  emits: ["update:selectedId"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

const props = __props;

const emits = __emit;

/**
 * 発注取込設定を選択する
 * @param selectedId - 選択した発注取込設定ID
 */
const selectOrderExcelInfo = (selectedId: string): void => {
  emits('update:selectedId', selectedId);
};

/**
 * 発注取込設定の行設定数表示を取得する
 * @param orderExcelInfo - 発注取込設定
 */
const getRowMappingRuleCountLabel = (orderExcelInfo: RegisterOrderExcelInfo): string => {
  return `${orderExcelInfo.rowMappingRules.length}${t('件')}`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('この発注ファイルの取り込みに使用する設定を選択してください。')), 1),
    _createElementVNode("div", {
      class: "order-excel-info-select-modal__list",
      role: "radiogroup",
      "aria-label": _unref(t)('発注取込設定')
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.orderExcelInfos, (orderExcelInfo) => {
        return (_openBlock(), _createElementBlock("label", {
          key: orderExcelInfo.id,
          class: _normalizeClass(["order-excel-info-select-modal__item", { 'order-excel-info-select-modal__item--selected': orderExcelInfo.id === props.selectedId }])
        }, [
          _createElementVNode("input", {
            class: "order-excel-info-select-modal__radio",
            type: "radio",
            name: "order-excel-info",
            value: orderExcelInfo.id,
            checked: orderExcelInfo.id === props.selectedId,
            onChange: ($event: any) => (selectOrderExcelInfo(orderExcelInfo.id))
          }, null, 40, _hoisted_4),
          _createElementVNode("span", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(orderExcelInfo.name), 1),
            _createElementVNode("span", _hoisted_7, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)('ヘッダー行')) + ": " + _toDisplayString(orderExcelInfo.headerLineNumber), 1),
              _createElementVNode("span", null, _toDisplayString(_unref(t)('行設定')) + ": " + _toDisplayString(getRowMappingRuleCountLabel(orderExcelInfo)), 1)
            ])
          ])
        ], 2))
      }), 128))
    ], 8, _hoisted_3)
  ]))
}
}

})